// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jg_a bhn_a bhn_j bhn_q bhn_sv bhn_sw bhn_w"};